// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rankDelta_delta__1KAyD {\n  font-size: 1rem;\n  position: relative;\n  width: fit-content;\n}\n.rankDelta_delta__1KAyD span {\n  position: absolute;\n  left: 100%;\n  font-size: 0.8rem;\n}\n\n.rankDelta_up__3ylhb {\n  color: var(--green);\n  margin: 0 auto;\n}\n.rankDelta_up__3ylhb span {\n  top: -30%;\n}\n\n.rankDelta_down__1SQQ0 {\n  color: var(--red);\n  margin: 0 auto;\n}\n.rankDelta_down__1SQQ0 span {\n  top: 40%;\n}", ""]);
// Exports
exports.locals = {
	"delta": "rankDelta_delta__1KAyD",
	"up": "rankDelta_up__3ylhb",
	"down": "rankDelta_down__1SQQ0"
};
module.exports = exports;
